import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material';
import React from 'react';
import { useWindowDimensions } from '../libraries/useWindowDimensions';

export default (props: BoxProps & { children: React.ReactNode | React.ReactNode[]; }) => {

    const windowDimensions = useWindowDimensions();

    return <Box {...props} sx={{ ...(props.sx ?? {}), minHeight: windowDimensions.height }} />;
};
